import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VmReferAFriendComponent } from './vm-refer-a-friend.component';
import { ButtonModule } from '@challenger6/vm-pattern-library/button';

@NgModule({
  declarations: [VmReferAFriendComponent],
  imports: [CommonModule, ButtonModule],
  exports: [VmReferAFriendComponent],
})
export class VmReferAFriendModule {}
